import type { MediaSticker, MediaStickerPack } from './api';
import { stickerGroupIds } from './stickerGroups';

export function searchTokens(value: string): string[] {
  return (
    value
      .normalize('NFKD')
      .replace(/\p{M}/gu, '')
      .toLowerCase()
      .match(/[\p{L}\p{N}]+/gu) ?? []
  );
}

export function matchesSticker(
  sticker: MediaSticker,
  query: string,
  packs: MediaStickerPack[],
): boolean {
  const terms = searchTokens(query);
  if (!terms.length) return true;
  const groupIds = stickerGroupIds(sticker);
  const groupNames = packs
    .filter((pack) => groupIds.includes(pack.packId))
    .map((pack) => pack.displayName);
  const tokens = searchTokens(
    [
      sticker.name,
      sticker.stickerId,
      sticker.sourceId ?? '',
      ...groupIds,
      ...groupNames,
      ...(sticker.keywords ?? []),
      ...(sticker.tags ?? []),
      sticker.style ?? '',
      sticker.styleName ?? '',
      ...(sticker.relatedCategoryIds ?? []),
    ].join(' '),
  );
  return terms.every((term) =>
    tokens.some((token) => (term.length <= 3 ? token === term : token.startsWith(term))),
  );
}

export function sortStickerPacks(packs: MediaStickerPack[]): MediaStickerPack[] {
  return [...packs].sort((a, b) => a.sortOrder - b.sortOrder || a.packId.localeCompare(b.packId));
}
